import { render, staticRenderFns } from "./ReviewGroupCard.vue?vue&type=template&id=5239980a&scoped=true"
import script from "./ReviewGroupCard.vue?vue&type=script&lang=js"
export * from "./ReviewGroupCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewGroupCard.vue?vue&type=style&index=0&id=5239980a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5239980a",
  null
  
)

export default component.exports